module.exports = __webpack_public_path__ + "static/media/plan_image.b4751afe.svg";